import CancelIcon from '@material-ui/icons/Cancel'
import { Elements } from '@tfo/common'
import LZstring from 'lz-string'
import { useIntl } from 'react-intl'
import './LoginFailWithSsoRedirect.scss'

const { Heading3, Paragraph } = Elements

type ErrorDetail = {
    type?: string
    title: string
    detail: string
    status: number
    errors: Record<string, string[]>
    traceId?: string
}

const missingErrorDetail: ErrorDetail = {
    status: 418,
    title: 'I\'m a teapot',
    detail: 'TEAPOT',
    errors: {}
}


const LoginFailWithSsoRedirect = () => {
    const params = new URLSearchParams(window.location.search)
    const body = params.get('e')
    const decompressedBody = body ? LZstring.decompressFromEncodedURIComponent(body) : null
    const errorDetails: ErrorDetail = decompressedBody ? JSON.parse(decompressedBody) : missingErrorDetail
    const intl = useIntl()

    return (
        <div className='login-fail-with-sso-redirect-inner'>
            <div className='check-icon-wrapper'>
                <CancelIcon />
            </div>

            <Heading3 className="login-failed-header">
                {intl.formatMessage({ id: 'sso.login.fail.title' })}
            </Heading3>

            <div className='login-fail-with-sso-redirect-text-body'>
                {errorDetails.status === 418 && RenderMissingError()}
                {errorDetails.status !== 418 && <Paragraph>{
                    intl.formatMessage(
                        { id: `sso.login.fail.preamble.${errorDetails.detail}` })}
                </Paragraph>}
            </div>

            {errorDetails.errors && <div className='login-fail-with-sso-redirect-subtext-wrapper'>
                <Paragraph small className='login-fail-with-sso-redirect-subtext'>
                    <ul>
                        {Object.keys(errorDetails.errors).map((key) => (
                            errorDetails.errors[key].map((error, index) => (
                                <li key={`${key}-${index}`}>
                                    {intl.formatMessage({ id: `sso.login.fail.error.key.${key}` })}: {intl.formatMessage({ id: `sso.login.fail.error.message.${error}` })}
                                </li>
                            ))
                        ))}
                    </ul>
                </Paragraph>
            </div>}
        </div>
    )
}

const RenderMissingError = () => {
    return <pre>{`                       (
            _           ) )
         _,(_)._        (( 
    ___,(_______).        )
  ,'__.   /       \\    /\\_
 /,' /  |""|       \\  /  /
| | |   |__|       |,'  /
 \\\\"."|                  /
  ". :           :    /
    ".            :.,'
Stef  "-.________,-' `}</pre>
}

export default LoginFailWithSsoRedirect